import S3FileUpload from './ReactS3Lib/ReactS3';
import { S3BucketConfig } from '../common/constants';
import moment from 'moment';

export const upload = async (file: any, token?: string): Promise<string | undefined> => {
  let newFileName;
  const filePath = file?.path || file?.name;

  if (file && filePath) {
    newFileName =
      filePath.split(/\.(?=[^\.]+$)/)[0] +
      moment().format('MMDDYYYYhmmss') +
      '.' +
      filePath.split(/\.(?=[^\.]+$)/)[1];
  }

  return await S3FileUpload.uploadFile(file, S3BucketConfig, newFileName, token)
    .then((data) => {
      return data.location;
    })
    .catch((err) => console.log(err));
};
